/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-unused-vars */
import { BaSeDialogContext, BaSeParagraph, BaSeTheme } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React from 'react';

import { useAnswerController } from '../../../../../hooks/controllers/answer-controller';
import { useEmailController } from '../../../../../hooks/controllers/email-controller';
import { useInterviewController } from '../../../../../hooks/controllers/interview-controller';
import { useQuizProfileController } from '../../../../../hooks/controllers/quiz-profile-controller.js';
import { useReportController } from '../../../../../hooks/controllers/report-controller';
import { useUserController } from '../../../../../hooks/controllers/user-controller.js';
import { useMessage } from '../../../../../hooks/messages/useMessage';
import { useInterviewService } from '../../../../../hooks/services/interview-service.js';
import { EditCandidate } from '../../../components/interview/edit-candidate';
import { ExpiredInterview } from '../../../components/interview/expired-interview';
import { FindCandidate } from '../../../components/interview/find-cadidate';
import { NewCandidate } from '../../../components/interview/new-candidate';
import VisualizarDadosCadastrais from '../../../components/interview/see-data-registration';
import VisualizarhistoricoEntrevista from '../../../components/interview/see-historic';
import { ModalContent } from '../candidates-styled';
import GenerateCertificate from '../components/certificate/generate/generate-certificate';
import SendMultipleCertificate from '../components/certificate/send/send-multiple-certificate';
import DeleteCertificate from '../components/delete-certificate/delete-certificate';
import FindManagerByName from '../components/find-manager-by-name-uf/find-manager-by-name.jsx';
import { GeneralSearch } from '../components/general-search/general-search.jsx';
import ModalDesist from '../components/modal-desist/modal-desist.jsx';
import VisualizarNotasRespostas from '../visualizar-notas-respostas';

const DESTACAR = 'Destacar candidato';
const REMOVER = 'Remover destaque';
const btnConfirm = 'Confirmar';
const btnCancel = 'Cancelar';
const btnEnviarCertificado = 'Enviar certificado';

const cache = Sebrae.StorageUtil.inTemporaryStore();

export const useCandidateInterview = () => {
  const { showModal, showNotification } = React.useContext(BaSeDialogContext);

  const {
    fetchData,
    data,
    buscarNotasRespostas,
    buscarRespostas,
    addHiglightInterview,
    removeHiglightInterview,
    buscarUrlCertificado,
    postSendInterviewCertificate,
    getDownloadCertificate,
    getValidateNewInterviewByExpiredStatus,
  } = useInterviewController();

  const { undoDesist, realizeDesist } = useInterviewService();

  const { sendEmailSubscription, sendEmailResult, enviarEmailReentrevista } =
    useEmailController();
  const { resendAnswerInterview, getAnswersByInterviewStartup } =
    useAnswerController();
  const { findSebrae } = useUserController();

  const { downloadPdf, getResultReport } = useReportController();
  const { hasRole } = Sebrae.useAuth();
  const [notasRespostas, setNotasRespostas] = React.useState({});
  const [showNotas, setShowNotas] = React.useState(false);
  const [showAvaliableCandidate, setShowAvaliableCandidate] =
    React.useState(false);

  const [showAvaliableRuralCandidate, setShowAvaliableRuralCandidate] =
    React.useState(false);

  const [respostas, setRespostas] = React.useState([]);
  const [dataToAvaliationRural, setDataToAvaliationRural] = React.useState({});

  const [respostasQuestionarioStartup, setRespostasQuestionarioStartup] =
    React.useState({});
  const [cod, setCod] = React.useState(0);
  const [codigoRespostas, setCodigoRespostas] = React.useState(0);
  const [hasApprove, setHasApprove] = React.useState(false);

  const { sendEmailQuiz } = useQuizProfileController();

  const getUrl = React.useCallback(() => {
    const url = window.location.protocol + '//' + window.location.host;
    return url;
  }, []);

  const { handleSuccess, handleError, handleAttention } = useMessage();

  const accessReport = React.useCallback(
    (content) => {
      getResultReport(content.id).then((pdf) => {
        pdf &&
          downloadPdf(
            pdf,
            `Relatório de entrevista - ${content.candidate.name}.pdf`,
          );
      });
    },
    [downloadPdf, getResultReport],
  );

  const openDialogSetOwner = React.useCallback(
    (isOwner, idInterview, reloadData) => {
      let content = '';
      return showModal({
        actions: [],
        size: 'medium',
        title: 'Incluir gestor responsável',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <FindManagerByName
            closeModal={closeModal}
            isOwner={isOwner}
            idInterview={idInterview}
            reloadData={reloadData}
          />
        ),
        onContentEvent: (name, payload) => (content = payload),
        onChooseAction: (action) => {},
      });
    },
    [showModal],
  );

  const openDialogInterviewExpired = React.useCallback(
    (
      interview,
      reloadData,
      openDialogCpf,
      openDialogActiveInterview,
      openDialogNewCandidate,
    ) => {
      let content = '';
      return showModal({
        actions: [],
        size: 'small',
        title: 'Novo Candidato',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <ExpiredInterview
            showMessage={false}
            interview={interview}
            action="Continuar expired"
            emitEvent={emitEvent}
            closeModal={closeModal}
          />
        ),
        onContentEvent: (name, payload) => (content = payload),
        onChooseAction: (action) => {
          handleSuccess('Candidato salvo com sucesso!');
          if (action === 'new') {
            setTimeout(() => {
              openDialogCpf(
                openDialogActiveInterview,
                openDialogNewCandidate,
                fetchData,
              );
            }, 1500);
            return;
          }
          if (action === 'close') {
            return setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        },
      });
    },
    [fetchData, handleSuccess, showModal],
  );

  const openDialogActiveInterview = React.useCallback(
    (interview) => {
      let content = '';
      return showModal({
        actions: [],
        size: 'small',
        title: 'Novo Candidato',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <FindCandidate
            showMessage={true}
            interview={interview}
            action="Acessar Relatório"
            emitEvent={emitEvent}
            closeModal={closeModal}
          />
        ),
        onContentEvent: (name, payload) => (content = payload),
        onChooseAction: () => accessReport(content),
      });
    },
    [accessReport, showModal],
  );

  const openDialogCertificateInterview = React.useCallback(
    (interview) => {
      let content = '';
      return showModal({
        actions: [],
        size: 'small',
        title: 'Novo Candidato',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <FindCandidate
            showMessage={true}
            interview={interview}
            action="Ok"
            emitEvent={emitEvent}
            closeModal={closeModal}
          />
        ),
        onContentEvent: (name, payload) => (content = payload),
        onChooseAction: () => accessReport(content),
      });
    },
    [accessReport, showModal],
  );

  const completeEditing = React.useCallback(
    (action, reloadData) => {
      if (action?.message) {
        handleError(
          'Erro ao tentar salvar os dados do candidato. ' + action.message,
        );
      } else {
        handleSuccess('Candidato salvo com sucesso!');
        return reloadData ? reloadData() : fetchData;
      }
    },
    [fetchData, handleError, handleSuccess],
  );

  const openDialogEditCandidate = React.useCallback(
    (interview, reloadData) => {
      return showModal({
        actions: [],
        size: 'small',
        title: 'Editar Candidato',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <EditCandidate
            interview={interview}
            emitEvent={emitEvent}
            closeModal={closeModal}
          />
        ),
        onChooseAction: (action) => {
          completeEditing(action, reloadData);
        },
      });
    },
    [showModal, completeEditing],
  );

  const openDialogEditActiveInterview = React.useCallback(
    (interview, fetchData) => {
      let content = '';
      return showModal({
        actions: [],
        size: 'small',
        title: 'Novo Candidato',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <FindCandidate
            showEditMessage={true}
            interview={interview}
            action="Editar informações"
            emitEvent={emitEvent}
            closeModal={closeModal}
          />
        ),
        onContentEvent: (name, payload) => (content = payload),
        onChooseAction: () => openDialogEditCandidate(interview, fetchData),
      });
    },
    [openDialogEditCandidate, showModal],
  );

  const openDialogCpf = React.useCallback(
    (openDialogActiveInterview, openDialogNewCandidate, fetchData) => {
      let content = '';
      return showModal({
        actions: [],
        size: 'small',
        title: 'Novo Candidato',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <FindCandidate
            showMessage={false}
            action="Continuar"
            emitEvent={emitEvent}
            closeModal={closeModal}
          />
        ),
        onContentEvent: (name, payload) => {
          return (content = payload);
        },
        onChooseAction: (action) => {
          fetchData({ ...data, sort: { type: 'DESC' } });

          const map = {
            candidate: () => openDialogNewCandidate(content, fetchData),
            editInterview: () =>
              openDialogEditActiveInterview(content, fetchData),
            activeInterview: () => openDialogActiveInterview(content),
            certificate: () => openDialogCertificateInterview(content),
            expiredInterview: () =>
              openDialogInterviewExpired(
                content,
                fetchData,
                openDialogCpf,
                openDialogActiveInterview,
                openDialogNewCandidate,
              ),
            reload: () => fetchData,
            close: () => null,
          };
          return action.error ? handleError(action.error) : map[action]();
        },
      });
    },
    [
      data,
      handleError,
      openDialogCertificateInterview,
      openDialogEditActiveInterview,
      openDialogInterviewExpired,
      showModal,
    ],
  );

  const openDialogNewCandidate = React.useCallback(
    (candidate, fetchData) => {
      return showModal({
        actions: [],
        size: 'small',
        title: 'Novo Candidato',
        content: ({ closeModal, emitEvent }) => (
          <NewCandidate
            showMessage={true}
            candidate={candidate}
            emitEvent={emitEvent}
            closeModal={closeModal}
          />
        ),
        onChooseAction: (action) => {
          handleSuccess('Candidato cadastrado com sucesso!');
          fetchData({ ...data, sort: { type: 'DESC' } });
          action === 'new' &&
            setTimeout(() => {
              openDialogCpf(
                openDialogActiveInterview,
                openDialogNewCandidate,
                fetchData,
              );
            }, 1500);
        },
      });
    },
    [data, handleSuccess, openDialogActiveInterview, openDialogCpf, showModal],
  );
  const openDialogNewInterviewExpiredStatus = React.useCallback(
    (values, preRegistation, reloadData) => {
      let content = '';

      return showModal({
        actions: [],
        size: 'small',
        title: 'Novo Candidato',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <FindCandidate
            interview={values}
            preRegistration={preRegistation}
            emitEvent={emitEvent}
            closeModal={closeModal}
          />
        ),
      });
    },
    [showModal],
  );

  const openDialogSendMultipleCertificate = React.useCallback(
    (interviews) => {
      return showModal({
        actions: [],
        size: 'small',
        title: 'Enviar certificado em lote',
        isFluid: true,
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal }) => (
          <SendMultipleCertificate
            interviews={interviews}
            closeModal={closeModal}
          />
        ),
      });
    },
    [showModal],
  );

  const openDialogGenerateCertificate = React.useCallback(
    (values, reloadData) => {
      let content = '';
      return showModal({
        actions: [],
        size: 'small',
        title: 'Gerar certificado',
        isFluid: true,
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <GenerateCertificate
            values={values}
            reloadData={reloadData}
            closeModal={closeModal}
          />
        ),
        onContentEvent: (name, payload) => (content = payload),
        onChooseAction: (action) => {},
        // onChooseAction: (action) => {
        //   const map = {
        //     candidate: () => openDialogNewCandidate(content, fetchData),
        //     editInterview: () => openDialogEditActiveInterview(content),
        //     activeInterview: () => openDialogActiveInterview(content),
        //     expiredInterview: () =>
        //       openDialogInterviewExpired(
        //         content,
        //         fetchData,
        //         openDialogCpf,
        //         openDialogActiveInterview,
        //         openDialogNewCandidate,
        //       ),
        //     close: () => null,
        //   };

        //   return action.error ? handleError(action.error) : map[action]();
        // },
      });
    },
    [showModal],
  );

  const openDialogDeleteCertificate = React.useCallback(
    (values, reloadData) => {
      let content = '';
      return showModal({
        actions: [],
        size: 'large',
        title: 'Excluir certificado',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <DeleteCertificate
            values={values}
            closeModal={closeModal}
            reloadData={reloadData}
          />
        ),
        onContentEvent: (name, payload) => (content = payload),
        onChooseAction: (action) => {},
      });
    },
    [showModal],
  );

  const openDialogBuscaGeral = React.useCallback(
    (handleCpfSearched) => {
      let content = '';
      return showModal({
        actions: [],
        size: 'small',
        title: 'Pesquisa Geral',
        dismissible: true,
        isFluid: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        breakpointDelimiter: 'mobileLarge',
        content: ({ closeModal, emitEvent }) => (
          <GeneralSearch
            handleCpfSearched={handleCpfSearched}
            openDialogCpf={openDialogCpf}
            closeModal={closeModal}
            openDialogNewCandidate={openDialogNewCandidate}
            openDialogActiveInterview={openDialogActiveInterview}
          />
        ),
        onContentEvent: (name, payload) => (content = payload),
      });
    },
    [
      openDialogActiveInterview,
      openDialogCpf,
      openDialogNewCandidate,
      showModal,
    ],
  );

  const showDialogSendEmail = React.useCallback(
    (callback, idsInterviews, reloadData) => {
      return showModal({
        actions: [
          {
            action: btnConfirm,
            type: 'primary',
            color: BaSeTheme.colors.institucionais.azulSebrae10,
          },
          btnCancel,
        ],
        alignActions: 'center',
        size: 'small',
        title: '',
        dismissible: false,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: () => (
          <ModalContent>
            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              Você confirma o envio do e-mail ao candidato?
            </BaSeParagraph>
          </ModalContent>
        ),
        onChooseAction: (action) => {
          if (action === btnConfirm) {
            callback({ idsInterviews }).then(() => reloadData());
          }
        },
      });
    },
    [showModal],
  );

  const showDialogSendEmailReentrevista = React.useCallback(
    (callback, id, reloadData) => {
      return showModal({
        actions: [
          {
            action: btnConfirm,
            type: 'primary',
            color: BaSeTheme.colors.institucionais.azulSebrae10,
          },
          btnCancel,
        ],
        alignActions: 'center',
        size: 'small',
        title: '',
        dismissible: false,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: () => (
          <ModalContent>
            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              Você confirma o envio do e-mail ao candidato?
            </BaSeParagraph>
          </ModalContent>
        ),
        onChooseAction: (action) => {
          if (action === btnConfirm) {
            callback(id).then(() => reloadData());
          }
        },
      });
    },
    [showModal],
  );

  const openDialogVisualizarHistorico = React.useCallback(
    (idCandidate) => {
      return showModal({
        actions: [],
        size: 'large',
        title: '‎ ',
        isFluid: true,
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: () => (
          <VisualizarhistoricoEntrevista idCandidate={idCandidate} />
        ),
      });
    },
    [showModal],
  );

  const openDialogVisualizarDadosCadastrais = React.useCallback(
    (values) => {
      return showModal({
        actions: [],
        size: 'large',
        title: 'Visualizar dados cadastrais',
        isFluid: true,
        breakpointDelimiter: 'desktop',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: () => <VisualizarDadosCadastrais values={values} />,
      });
    },
    [showModal],
  );

  React.useEffect(() => {
    if (cod === 0 || cod === 1) return;
    return showModal({
      actions: [],
      size: 'medium',
      isFluid: true,
      title: '',
      dismissible: true,
      dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
      dismissibleIconType: 'tertiary',
      content: () => (
        <VisualizarNotasRespostas
          notasRespostas={notasRespostas}
          respostas={respostas}
          setShowNotas={setShowNotas}
          codigo={2}
        />
      ),
    });
  }, [cod, notasRespostas, respostas, showModal]);

  const assembleMenuSendEmailSelfAvaliation = React.useCallback(
    (values, menuItems, reloadData) => {
      if (
        values?.module.id === 2 &&
        values.statusInterview === 'APTO' &&
        values?.statusCompletingInterview === 'FINALIZADA'
      ) {
        menuItems.push({
          text: 'Enviar e-mail de autoavaliação',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'envelope-share',
          callback: () => {
            sendEmailQuiz(values?.id)
              .then(() => {
                handleSuccess('E-mail enviado com sucesso!');
              })
              .catch(() => {
                handleError('Erro ao enviar email de autoavaliação!');
              });
          },
        });
      }
    },
    [handleError, handleSuccess, sendEmailQuiz],
  );

  const assembleMenuByError400 = React.useCallback(
    (values, menuItems, reloadData) => {
      if (
        values?.statusCompletingInterview === 'REENTREVISTA' &&
        values?.statusInterview === 'SEM_RESULTADO'
      ) {
        menuItems.push({
          text: 'Reenviar e-mail de entrevista',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'envelope-share',
          callback: () =>
            showDialogSendEmailReentrevista(
              enviarEmailReentrevista,
              values?.id,
              reloadData,
            ),
        });
      }
    },
    [enviarEmailReentrevista, showDialogSendEmailReentrevista],
  );

  const assembleMenuReportOrInterview = React.useCallback(
    (values, menuItems, reloadData) => {
      if (
        values.module.id === 2 &&
        (values.statusCompletingInterview === 'EM_PREENCHIMENTO' ||
          values.statusCompletingInterview === 'NAO_PREENCHIDO' ||
          values.statusInterview === 'NAO_APTO')
      )
        return;

      if (
        values.statusInterview === 'AGUARDANDO_AVALIACAO' ||
        values?.statusInterview === 'SEM_RESULTADO' ||
        values.statusInterview === 'ERRO_DE_PROCESSAMENTO' ||
        values.statusCompletingInterview === 'EM_PREENCHIMENTO' ||
        values.statusCompletingInterview === 'NAO_PREENCHIDO' ||
        values.statusCompletingInterview === 'REENTREVISTA' ||
        values.statusCompletingInterview === 'EM_REVISAO'
      )
        return;
      menuItems.push({
        text: `${'Relatório de perfil'}`,
        color: BaSeTheme.colors.institucionais.cinzaSebrae45,
        icon: 'receipt-alt',
        callback: () =>
          getResultReport(values.id).then((pdf) => {
            pdf &&
              downloadPdf(
                pdf,
                `Relatório de perfil - ${values.candidate.name}.pdf`,
              );
          }),
      });
    },
    [downloadPdf, getResultReport],
  );

  // const assembleSeeCertificate = React.useCallback(
  //   (values, menuItems, reloadData) => {
  //     if (values?.statusCompletingInterview === 'CERTIFICADA') {
  //       menuItems.push({
  //         text: 'Visualizar certificado',
  //         color: BaSeTheme.colors.institucionais.cinzaSebrae45,
  //         icon: 'document-layout-left',
  //         callback: () => {
  //           buscarUrlCertificado(values?.id)
  //             .then((response) => {
  //               if (response?.message) {
  //                 handleAttention(response?.message);
  //                 return;
  //               }
  //               if (response?.urlViewCertificate) {
  //                 window.open(response?.urlViewCertificate, '_blank');
  //               }
  //             })
  //             .catch((error) => {
  //               handleError(error);
  //             });
  //         },
  //       });
  //     }
  //   },
  //   [buscarUrlCertificado, handleAttention, handleError],
  // );

  const assembleMenuByStatus = React.useCallback(
    (values, menuItems, reloadData) => {
      if (
        values.statusInterview === 'APTO' ||
        values.statusInterview === 'NAO_APTO'
      ) {
        menuItems.push({
          text: 'Reenviar e-mail de resultado',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'envelope-share',
          callback: () => {
            showDialogSendEmail(sendEmailResult, [values.id], reloadData);
          },
        });
      }

      if (values.statusInterview === 'ERRO_DE_PROCESSAMENTO') {
        menuItems.push({
          text: 'Reprocessar entrevista',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'envelope-share',
          callback: () => {
            resendAnswerInterview(values.id)
              .then((reponse) => {
                handleSuccess(
                  'Solicitação de reprocessamento da(s) entrevista(s) enviada com sucesso.',
                );
              })
              .catch((error) => handleError(error.message));
            reloadData();
          },
        });
      }

      return menuItems;
    },
    [
      handleError,
      handleSuccess,
      resendAnswerInterview,
      sendEmailResult,
      showDialogSendEmail,
    ],
  );

  const assembleMenuByResult = React.useCallback(
    (values, menuItems, reloadData) => {
      if (values.statusCompletingInterview !== 'EXPIRADA') {
        menuItems.push({
          text: 'Editar',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'edit',
          callback: () => {
            openDialogEditCandidate(values, reloadData);
          },
        });
      }

      if (
        values.statusCompletingInterview === 'EXPIRADA' &&
        values.showMenuNewInterview
      ) {
        menuItems.push({
          text: 'Criar nova entrevista',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'comment-plus',
          callback: () => {
            getValidateNewInterviewByExpiredStatus(
              values.id,
              values.module.id,
              values.candidate.cpf,
            ).then((data) => {
              if (data?.valid) {
                openDialogInterviewExpired(
                  values,
                  fetchData,
                  openDialogCpf,
                  openDialogActiveInterview,
                  openDialogNewCandidate,
                );
                return;
              }

              if (!data?.valid && data?.message) {
                handleAttention(data.message);
                return;
              }

              if (!data?.valid && data?.preRegistration) {
                openDialogNewInterviewExpiredStatus(
                  values,
                  data?.preRegistration,
                  reloadData,
                );
                return;
              }
            });
          },
        });
      }

      if (
        values.statusCompletingInterview === 'EM_PREENCHIMENTO' ||
        values.statusCompletingInterview === 'NAO_PREENCHIDO'
      ) {
        menuItems.push({
          text: 'Enviar e-mail de inscrição',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'envelope-share',
          callback: () =>
            showDialogSendEmail(sendEmailSubscription, [values.id], reloadData),
        });
      }
    },
    [
      fetchData,
      getValidateNewInterviewByExpiredStatus,
      handleAttention,
      openDialogActiveInterview,
      openDialogCpf,
      openDialogEditCandidate,
      openDialogInterviewExpired,
      openDialogNewCandidate,
      openDialogNewInterviewExpiredStatus,
      sendEmailSubscription,
      showDialogSendEmail,
    ],
  );

  const assembleMenuByRole = React.useCallback(
    (values, menuItems, code) => {
      if (
        values.module.id === 4 &&
        values.statusInterview === 'AGUARDANDO_AVALIACAO'
      ) {
        return;
      }
      if (
        values.module.id !== 2 &&
        hasRole('ADMINISTRADOR') &&
        (values.statusInterview === 'APTO' ||
          values.statusInterview === 'NAO_APTO' ||
          values.statusInterview === 'AGUARDANDO_AVALIACAO' ||
          values.statusCompletingInterview === 'DESISTENTE')
      ) {
        menuItems.push({
          text: 'Visualizar notas e respostas',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'list-ul',
          callback: async () => {
            try {
              const respostas = await buscarRespostas(values.id);
              setRespostas(respostas);

              const notasRespostas = await buscarNotasRespostas(values.id);
              if (notasRespostas === undefined) {
                return;
              }

              setNotasRespostas(notasRespostas);
              setShowNotas((prev) => !prev);
              setCod(code);
            } catch (error) {
              handleError('Erro ao visualizar notas e respostas!');
            }
          },
        });
      }
    },
    [buscarNotasRespostas, buscarRespostas, handleError, hasRole],
  );

  const showDialogDesist = React.useCallback(
    (id, title, name, isRealize, reloadData) => {
      return showModal({
        actions: [
          {
            action: 'Sim',
            color: BaSeTheme.colors.defaultColors.black,
          },
          {
            action: 'Não',
            type: 'secondary',
            color: BaSeTheme.colors.defaultColors.black,
          },
        ],
        alignActions: 'left',
        size: 'small',
        title: `${title} desistência`,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: () => <ModalDesist name={name} isRealize={isRealize} />,
        onChooseAction: (action) => {
          if (action === 'Sim') {
            isRealize
              ? realizeDesist(id)
                  .then(() => {
                    handleSuccess('Status alterado com sucesso!');
                    reloadData();
                  })
                  .catch(() => {
                    handleError('Erro ao alterar o status para desistente!');
                  })
              : undoDesist(id)
                  .then(() => {
                    handleSuccess('Status alterado com sucesso!');
                    reloadData();
                  })
                  .catch(() => {
                    handleError('Erro ao alterar o status para desistente!');
                  });
          }
        },
      });
    },
    [handleError, handleSuccess, realizeDesist, showModal, undoDesist],
  );

  const assembleMenuDropout = React.useCallback(
    (values, menuItems, reloadData) => {
      if (
        values.statusCompletingInterview === 'FINALIZADA' &&
        values.statusInterview === 'APTO'
      ) {
        menuItems.push({
          text: 'Realizar desistência',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'ban',
          callback: () => {
            showDialogDesist(
              values.id,
              'Confirmar',
              values?.candidate?.name,
              true,
              reloadData,
            );
          },
        });
      }
    },
    [showDialogDesist],
  );

  const assembleMenuSetOwner = React.useCallback(
    (values, menuItems, reloadData) => {
      if (
        cache.hasItem('@empretec:sebrae') &&
        (cache.getItem('@empretec:sebrae') === 'NA' ||
          cache.getItem('@empretec:sebrae') === values.city.uf.initials)
      ) {
        menuItems.push({
          text: 'Incluir gestor responsável',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'user-plus',
          callback: () => {
            openDialogSetOwner(values.owner, values.id, reloadData);
          },
        });
      }
    },
    [openDialogSetOwner],
  );

  const assembleMenuUndoDropout = React.useCallback(
    (values, menuItems, reloadData) => {
      if (
        values.statusCompletingInterview === 'DESISTENTE' &&
        values.statusInterview === 'CONCLUIDO'
      ) {
        menuItems.push({
          text: 'Desfazer desistência',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'system/arrow-go-back-line',
          callback: () => {
            showDialogDesist(
              values.id,
              'Desfazer',
              values?.candidate?.name,
              false,
              reloadData,
            );
          },
        });
      }
    },
    [showDialogDesist],
  );

  const assembleMenuSeeInterviewCandidate = React.useCallback(
    (values, menuItems) => {
      if (
        (values.statusCompletingInterview === 'REENTREVISTA' ||
          (values.module.id !== 2 &&
            values.module.id !== 4 &&
            values.statusInterview === 'AGUARDANDO_AVALIACAO') ||
          values.statusCompletingInterview === 'EM_REVISAO' ||
          values.statusCompletingInterview === 'NAO_PREENCHIDO' ||
          values.statusCompletingInterview === 'EM_PREENCHIMENTO' ||
          (values.statusCompletingInterview === 'FINALIZADA' &&
            values.statusInterview === 'ERRO_DE_PROCESSAMENTO')) &&
        hasRole('ADMINISTRADOR')
      ) {
        menuItems.push({
          text: `${
            values.module.id === 2
              ? 'Acessar questionário'
              : 'Acessar entrevista'
          }`,
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'edit-alt',
          callback: () => {
            window.open(`${getUrl()}/candidato/id/${values.id}`, '_blank');
          },
        });
      }
    },
    [getUrl, hasRole],
  );

  const assembleMenuByHistoric = React.useCallback(
    (values, menuItems) => {
      if (values.hasHistoric) {
        menuItems.push({
          text: 'Visualizar histórico',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'file-search-alt',
          callback: () => {
            setCodigoRespostas(values.id);
            openDialogVisualizarHistorico(values.candidate.id);
          },
        });
      }
    },
    [openDialogVisualizarHistorico],
  );

  const assembleMenuSendDigitalCertificate = React.useCallback(
    (values, menuItems) => {
      if (values.statusCompletingInterview === 'CERTIFICADA') {
        menuItems.push({
          text: 'Enviar certificado digital',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'envelope-share',
          callback: () => {
            const data = {
              idsInterviews: [values.id],
              sendAll: false,
            };
            postSendInterviewCertificate(data);
          },
        });
      }
    },
    [postSendInterviewCertificate],
  );

  const assembleMenuDeleteCertificate = React.useCallback(
    (values, menuItems, reloadData) => {
      if (values.statusCompletingInterview === 'CERTIFICADA') {
        menuItems.push({
          text: 'Excluir certificado',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'system/close-line',
          callback: () => {
            openDialogDeleteCertificate(values, reloadData);
          },
        });
      }
    },
    [openDialogDeleteCertificate],
  );

  const assembleDownloadCertificate = React.useCallback(
    (values, menuItems) => {
      if (values.statusCompletingInterview === 'CERTIFICADA') {
        menuItems.push({
          text: 'Imprimir certificado',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'receipt',
          callback: () => {
            getDownloadCertificate(values.id).then((response) => {
              response && downloadPdf(response, 'certificado.pdf');
            });
          },
        });
      }
    },
    [downloadPdf, getDownloadCertificate],
  );

  const destacarEntrevista = React.useCallback(
    (id, reload) => {
      addHiglightInterview(id)
        .then(() => {
          showNotification({
            message: 'Candidato destacado',
            supportMessage:
              'Candidato marcado como destaque no seminário Empretec com sucesso!',
            secondsToClose: 5,
            color: 'confirmation',
            action: 'Desfazer',
            onActionClose: () => {
              removeHiglightInterview(id)
                .then(() => {
                  showNotification({
                    message: 'Candidato desmarcado',
                    supportMessage:
                      'Candidato desmarcado como destaque no seminário Empretec com sucesso!',
                    secondsToClose: 5,
                    color: 'confirmation',
                    action: 'Desfazer',
                    onActionClose: () => {
                      destacarEntrevista(id, reload);
                    },
                  });
                })
                .finally(() => reload())
                .catch(() =>
                  handleError('Erro ao remover destaque aa entrevista!'),
                );
            },
          });
        })
        .finally(() => reload())
        .catch(() => handleError('Erro ao destacar a entrevista!'));
    },
    [
      addHiglightInterview,
      handleError,
      removeHiglightInterview,
      showNotification,
    ],
  );

  const removerDestaqueEntrevista = React.useCallback(
    (id, reload) => {
      removeHiglightInterview(id)
        .then(() => {
          showNotification({
            message: 'Candidato desmarcado',
            supportMessage:
              'Candidato desmarcado como destaque no seminário Empretec com sucesso!',
            secondsToClose: 5,
            color: 'confirmation',
            action: 'Desfazer',
            onActionClose: () => {
              destacarEntrevista(id, reload);
            },
          });
        })
        .finally(() => reload())
        .catch(() => handleError('Erro ao remover destaque aa entrevista!'));
    },
    [
      destacarEntrevista,
      handleError,
      removeHiglightInterview,
      showNotification,
    ],
  );

  const assembleMenuHiglight = React.useCallback(
    (values, menuItems, reloadData) => {
      if (!values.highligth && values.addHighligth && values.module.id !== 2) {
        menuItems.push({
          text: DESTACAR,
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          // isDisabled: !values.highligth && !values.removeHighligth,
          icon: 'star',
          callback: () => {
            destacarEntrevista(values.id, reloadData);
          },
        });
      }

      if (values.highligth && values.module.id !== 2) {
        menuItems.push({
          text: REMOVER,
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          isDisabled: !values.removeHighligth,
          icon: 'close',
          callback: () => {
            removerDestaqueEntrevista(values.id, reloadData);
          },
        });
      }
    },
    [destacarEntrevista, removerDestaqueEntrevista],
  );

  const assembleGenerateCertificateSingle = React.useCallback(
    (values, menuItems, reloadData) => {
      if (
        values.statusInterview === 'APTO' &&
        (values.statusCompletingInterview === 'FINALIZADA' ||
          values.statusCompletingInterview === 'EXPIRADA')
      ) {
        menuItems.push({
          text: 'Gerar certificado',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'document-layout-left',
          callback: () => {
            const interview = [values];
            openDialogGenerateCertificate(interview, reloadData);
          },
        });
      }
    },
    [openDialogGenerateCertificate],
  );

  const getInterviewDataStartup = React.useCallback(
    (id) => {
      getAnswersByInterviewStartup(id)
        .then((response) => setRespostasQuestionarioStartup(response))
        .catch((error) => console.log(error));
    },
    [getAnswersByInterviewStartup],
  );

  const assembleMenuEditionRuralAvaliable = React.useCallback(
    (values, menuItems, reloadData) => {
      if (
        values.module.id === 4 &&
        values.statusCompletingInterview === 'FINALIZADA' &&
        values.statusInterview === 'APTO'
      ) {
        menuItems.push({
          text: 'Editar avaliação de perfil',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'edit',
          callback: async () => {
            try {
              const response = await buscarNotasRespostas(values.id);
              setDataToAvaliationRural({
                interviewId: values.id,
                ...response,
              });
              setShowAvaliableRuralCandidate((prev) => !prev);
            } catch (error) {
              handleError('Erro ao visualizar notas e respostas!');
              return;
            }
          },
        });
      }
    },
    [buscarNotasRespostas, handleError],
  );

  const assembleMenuRuralAvaliable = React.useCallback(
    (values, menuItems, reloadData) => {
      if (
        values.module.id === 4 &&
        values.statusInterview !== 'AGUARDANDO_AVALIACAO'
      )
        return;
      menuItems.push({
        text: 'Avaliar candidato',
        color: BaSeTheme.colors.institucionais.cinzaSebrae45,
        icon: 'design/edit-2-line',
        callback: async () => {
          try {
            const response = await buscarNotasRespostas(values.id);
            setDataToAvaliationRural({
              interviewId: values.id,
              ...response,
            });
            setShowAvaliableRuralCandidate((prev) => !prev);
          } catch (error) {
            handleError('Erro ao visualizar notas e respostas!');
            return;
          }
        },
      });
    },
    [buscarNotasRespostas, handleError],
  );

  const assembleLinkAvaliable = React.useCallback(
    (values, menuItems, reloadData) => {
      if (values.module.id !== 2) return;
      if (values.statusInterview === 'AGUARDANDO_AVALIACAO') {
        menuItems.push({
          text: 'Avaliar questionário de seleção',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'design/edit-2-line',
          callback: () => {
            setShowAvaliableCandidate((prev) => !prev);
            getInterviewDataStartup(values.id);
            setHasApprove(true);
          },
        });
      }
    },
    [getInterviewDataStartup],
  );

  const assembleMenuSeeQuestionarieSelection = React.useCallback(
    (values, menuItems, reloadData) => {
      if (values.statusInterview === 'AGUARDANDO_AVALIACAO') return;
      if (
        values.module.id === 2 &&
        (values.statusCompletingInterview === 'FINALIZADA' ||
          values.statusCompletingInterview === 'CERTIFICADA' ||
          values.statusCompletingInterview === 'DESISTENTE' ||
          values.statusInterview === 'APTO' ||
          values.statusInterview === 'NAO_APTO')
      ) {
        menuItems.push({
          text: 'Visualizar questionário de seleção',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          icon: 'eye',
          callback: () => {
            setShowAvaliableCandidate((prev) => !prev);
            getInterviewDataStartup(values.id);
            setHasApprove(false);
          },
        });
      }
    },
    [getInterviewDataStartup],
  );

  //URBANO APTO & FINALIZADO && PILOTO ||ADMINISTRADOR
  //ARENA APTO & FINALIZADO && PILOTO ||ADMINISTRADOR
  //STARTUP APTO & FINALIZADO
  const assembleLinkJohari = React.useCallback(
    (values, menuItems) => {
      if (
        values.module.id !== 2 &&
        (values.statusInterview !== 'APTO' ||
          values.statusCompletingInterview !== 'FINALIZADA') &&
        (!hasRole('PILOTO') || !hasRole('ADMINISTRADOR'))
      ) {
        return;
      }

      if (
        values.module.id === 2 &&
        (values.statusInterview !== 'APTO' ||
          values.statusCompletingInterview !== 'FINALIZADA')
      ) {
        return;
      }

      menuItems.push({
        text: 'Link para coleta de percepção',
        color: BaSeTheme.colors.institucionais.cinzaSebrae45,
        icon: 'copy',
        callback: () => {
          navigator.clipboard
            .writeText(
              `${getUrl()}/candidato/${values.module.id}/questionario/${
                values.candidate.cpf
              }`,
            )
            .then(() => {
              handleSuccess('Link copiado com sucesso.');
            })
            .catch((err) => {
              handleError('Erro ao copiar link de Johari...');
            });
        },
      });
    },
    [getUrl, handleSuccess, handleError, hasRole],
  );

  const assembleSeeDataCredential = React.useCallback(
    (values, menuItems) => {
      menuItems.push({
        text: 'Visualizar dados cadastrais',
        color: BaSeTheme.colors.institucionais.cinzaSebrae45,
        icon: 'eye',
        callback: () => {
          openDialogVisualizarDadosCadastrais(values);
        },
      });
    },
    [openDialogVisualizarDadosCadastrais],
  );

  const assembleGroupCertificate = React.useCallback(
    (values, menuItems, reloadData) => {
      if (values?.statusCompletingInterview === 'CERTIFICADA') {
        menuItems.push({
          text: 'Certificado',
          icon: 'document-layout-left',
          color: BaSeTheme.colors.institucionais.cinzaSebrae45,
          subitems: [
            {
              text: 'Visualizar certificado',
              color: BaSeTheme.colors.institucionais.cinzaSebrae45,
              icon: 'document-layout-left',
              closeOnAction: true,
              callback: () => {
                buscarUrlCertificado(values?.id)
                  .then((response) => {
                    if (response?.message) {
                      handleAttention(response?.message);
                    }
                    if (response?.urlViewCertificate) {
                      window.open(response?.urlViewCertificate, '_blank');
                    }
                  })
                  .catch((error) => {
                    handleError(error);
                  });
              },
            },
            {
              text: 'Imprimir certificado',
              color: BaSeTheme.colors.institucionais.cinzaSebrae45,
              icon: 'receipt',
              callback: () => {
                getDownloadCertificate(values.id).then((response) => {
                  response && downloadPdf(response, 'certificado.pdf');
                });
              },
            },
            {
              text: 'Enviar certificado digital',
              color: BaSeTheme.colors.institucionais.cinzaSebrae45,
              icon: 'envelope-share',
              callback: () => {
                const data = {
                  idsInterviews: [values.id],
                  sendAll: false,
                };
                postSendInterviewCertificate(data);
              },
            },
            {
              text: 'Excluir certificado',
              color: BaSeTheme.colors.institucionais.cinzaSebrae45,
              icon: 'system/close-line',
              callback: () => {
                openDialogDeleteCertificate(values, reloadData);
              },
            },
          ],
        });
      }
    },
    [
      buscarUrlCertificado,
      handleAttention,
      handleError,
      getDownloadCertificate,
      downloadPdf,
      postSendInterviewCertificate,
      openDialogDeleteCertificate,
    ],
  );

  const getMenuItems = React.useCallback(
    (values, reloadData, code) => {
      const menuItems = [];

      assembleMenuByResult(values, menuItems, reloadData);
      assembleMenuByStatus(values, menuItems, reloadData);
      assembleLinkJohari(values, menuItems);
      assembleMenuReportOrInterview(values, menuItems, reloadData);
      assembleSeeDataCredential(values, menuItems);
      assembleMenuSeeInterviewCandidate(values, menuItems);
      assembleGenerateCertificateSingle(values, menuItems, reloadData);
      assembleMenuByRole(values, menuItems, code);
      assembleMenuEditionRuralAvaliable(values, menuItems, reloadData);
      assembleLinkAvaliable(values, menuItems, reloadData);
      assembleMenuRuralAvaliable(values, menuItems, reloadData);
      assembleMenuDropout(values, menuItems, reloadData);
      assembleMenuUndoDropout(values, menuItems, reloadData);
      assembleMenuHiglight(values, menuItems, reloadData);
      assembleMenuByError400(values, menuItems, reloadData);
      assembleMenuSetOwner(values, menuItems, reloadData);
      assembleGroupCertificate(values, menuItems, reloadData);
      assembleMenuSendEmailSelfAvaliation(values, menuItems, reloadData);
      assembleMenuSeeQuestionarieSelection(values, menuItems, reloadData);
      // assembleSeeCertificate(values, menuItems, reloadData);
      // assembleDownloadCertificate(values, menuItems);
      // assembleMenuSendDigitalCertificate(values, menuItems);
      // assembleMenuDeleteCertificate(values, menuItems, reloadData);

      return menuItems;
    },
    [
      assembleMenuByResult,
      assembleMenuByStatus,
      assembleLinkJohari,
      assembleMenuReportOrInterview,
      assembleSeeDataCredential,
      assembleMenuEditionRuralAvaliable,
      assembleMenuSeeInterviewCandidate,
      assembleGenerateCertificateSingle,
      assembleMenuByRole,
      assembleLinkAvaliable,
      assembleMenuDropout,
      assembleMenuUndoDropout,
      assembleMenuHiglight,
      assembleMenuByError400,
      assembleMenuSetOwner,
      assembleGroupCertificate,
      assembleMenuSendEmailSelfAvaliation,
      assembleMenuSeeQuestionarieSelection,
      assembleMenuRuralAvaliable,
    ],
  );

  function padTo2Digits(num) {
    if (!num) return;
    return num.toString().padStart(2, '0');
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  function formatDate(date) {
    if (!date) return;
    return [
      padTo2Digits(date.getDate()),
      padTo2Digits(date.getMonth() + 1),
      date.getFullYear(),
    ].join('/');
  }

  return {
    assembleMenuByHistoric,
    assembleMenuByRole,
    assembleMenuByResult,
    assembleMenuByStatus,
    openDialogVisualizarHistorico,
    showDialogSendEmail,
    openDialogNewCandidate,
    openDialogCpf,
    openDialogEditActiveInterview,
    openDialogEditCandidate,
    openDialogActiveInterview,
    getMenuItems,
    setShowNotas,
    formatDate,
    handleSuccess,
    handleError,
    handleAttention,
    accessReport,
    setCodigoRespostas,
    openDialogGenerateCertificate,
    openDialogSendMultipleCertificate,
    openDialogBuscaGeral,
    showNotas,
    notasRespostas,
    respostas,
    showAvaliableCandidate,
    setShowAvaliableCandidate,
    respostasQuestionarioStartup,
    getInterviewDataStartup,
    hasApprove,
    setHasApprove,
    showAvaliableRuralCandidate,
    setShowAvaliableRuralCandidate,
    dataToAvaliationRural,
  };
};
